<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <div>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down">
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <form
          @keyup.enter="
            pageNo = 1;
            getData();
          "
        >
          <div class="vx-row mb-2">
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>از تاریخ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5  w-full"
                    v-model="filters.transactionDateFrom"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>تا تاریخ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5 w-full"
                    v-model="filters.transactionDateTo"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>از مبلغ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.minAmount"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>تا مبلغ:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.maxAmount"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>موبایل:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.consumerMobile"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>نام پرداخت کننده:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input v-model="filters.consumerName" class="w-full" />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>عنوان قبض:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input v-model="filters.billTitle" class="w-full" />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 flex-inline">
                  <span>شرح قبض:</span>
                </div>
                <div class="vx-col sm:w-2/3 flex-inline">
                  <vs-input v-model="filters.billDescription" class="w-full" />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-10/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/6 flex-inline">
                  <span>سایر ستونها:</span>
                </div>
                <div class="vx-col sm:w-5/6 flex-inline">
                  <vs-input
                    v-model="filters.merchantDescription"
                    class="w-full"
                    placeholder="شرح1:________ ، شرح2:________"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col">
              <vs-button
                @click="clear"
                class="mx-3"
                color="primary"
                type="border"
                >پاک کردن</vs-button
              >
            </div>
            <div class="vx-col">
              <vs-button
                @click="
                  pageNo = 1;
                  getData(false);
                "
                class="mx-3"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                >جستجو</vs-button
              >
            </div>
          </div>
        </form>
      </vs-collapse-item>
    </vs-collapse>
    <vx-card>
      <!-- pagination :max-items="100" -->
      <vs-table
        id="tbl2"
        ref="tbl2"
        :max-items="paginationPageSize"
        stripe
        :data="tableData"
        class="responsable-table"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <vs-dropdown color="red">
                    <a class="flex items-center" href="#">
                      دانلود
                      <i class="material-icons">expand_more</i>
                    </a>

                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="download(1)"
                        >نوع 1</vs-dropdown-item
                      >

                      <vs-dropdown-item @click="download(2)"
                        >نوع 2</vs-dropdown-item
                      >

                      <vs-dropdown-item @click="download(3)"
                        >نوع 3</vs-dropdown-item
                      >

                      <vs-dropdown-item @click="download(4)"
                        >نوع 4</vs-dropdown-item
                      >
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <vs-popup
            class="holamundo"
            title="انتخاب ستونهای خروجی اکسل"
            :active.sync="popupActive"
          >
            <vs-list>
              <draggable class="cursor-move">
                <vs-list-item
                  class="flex items-center p-1"
                  title="نام مشتری"
                ></vs-list-item>
                <vs-list-item
                  class="flex items-center p-1"
                  title="شماره مشتری"
                ></vs-list-item>
                <vs-list-item
                  class="flex items-center p-1"
                  title="مبلغ"
                ></vs-list-item>
                <vs-list-item
                  class="flex items-center p-1"
                  title="تاریخ پرداخت"
                ></vs-list-item>
                <vs-list-item
                  class="flex items-center p-1"
                  title="وضعیت"
                ></vs-list-item>
                <vs-list-item
                  class="flex items-center p-1"
                  title="سایر"
                ></vs-list-item>
                <!-- <vs-list-item class="flex items-center p-1" v-for="(item, index) in list" :key="index" :title="item">
                </vs-list-item>-->
              </draggable>
            </vs-list>

            <div class="vx-row mb-2">
              <div class="vx-col">
                <vs-button
                  @click="download"
                  class="mx-3"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-download"
                  >دانلود</vs-button
                >
              </div>
            </div>
          </vs-popup>
        </template>

        <template slot="thead">
          <vs-th class="px-1">ردیف</vs-th>
          <vs-th sort-key="consumerName" key="consumerName">نام مشتری</vs-th>
          <vs-th sort-key="consumerMobile" key="consumerMobile"
            >شماره مشتری</vs-th
          >
          <vs-th sort-key="amount" key="amount">مبلغ</vs-th>
          <vs-th sort-key="billTitle" key="billTitle">عنوان قبض</vs-th>
          <vs-th
            sort-key="paymentTransactionDateTime"
            key="paymentTransactionDateTime"
            >تاریخ پرداخت</vs-th
          >
          <vs-th sort-key="billState" key="billState">وضعیت</vs-th>
          <vs-th>توضیحات</vs-th>
          <vs-th class="m-only">سایر</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="tr.billReciverId" v-for="(tr, indextr) in data">
            <vs-td class="pr-0 d-only">
              {{ pageSize * (pageNo - 1) + indextr + 1 }}
            </vs-td>
            <vs-td>{{
              !tr.consumerName
                ? !tr.contactName
                  ? tr.consumerMobile
                  : tr.contactName
                : tr.consumerName
            }}</vs-td>
            <vs-td>{{
              tr.consumerMobile == null
                ? /^(\+98|0)9\d{9}$/.test(tr.consumerName)
                  ? tr.consumerName
                  : ""
                : tr.consumerMobile
            }}</vs-td>
            <vs-td>
              {{ parseInt(tr.amount).toLocaleString() }}
              <span class="m-only">
                <vs-button
                  color="success"
                  type="line"
                  icon-pack="feather"
                  icon="icon-check-circle"
                  class="p-0 pb-1 float-right"
                  @click="showTransaction(tr.transactionId)"
                  >تراکنش</vs-button
                >
                <share-links
                  class="float-right mt-1"
                  btnText="اشتراک"
                  :cssClass="'p-0 text-' + BillState[tr.billState].color"
                  :message="'https://pay.bistpay.com/2/2/' + tr.billReceiverId"
                  :receiver="tr.consumerMobile"
                ></share-links>
              </span>
            </vs-td>
            <vs-td>{{ tr.billTitle }}</vs-td>
            <vs-td class="e-col">{{
              !tr.paymentTransactionDateTime ||
              tr.paymentTransactionDateTime == "0001-01-01T00:00:00"
                ? "-"
                :$moment(tr.paymentTransactionDateTime).format(
                    "HH:mm:ss - jYYYY/jM/jD"
                  )
            }}</vs-td>
            <vs-td class="d-only">
              <feather-icon
                :title="BillState[tr.billState].title"
                :icon="BillState[tr.billState].icon"
                :svgClasses="[
                  `h-6 w-6 stroke-current text-${
                    BillState[tr.billState].color
                  }`,
                ]"
              ></feather-icon>
            </vs-td>
            <vs-td class="e-col">
              <span class="vx-row">شرح قبض:{{ tr.billDescription }}</span>
            </vs-td>
            <vs-td class="m-only e-col hide-title py-0">
              <template v-if="!$helper.isJSON(tr.merchantDescription)">{{
                tr.merchantDescription
              }}</template>
              <template v-else>
                <span
                  class="mx-0 block py-1"
                  :key="item"
                  v-for="item in tr.merchantDescription
                    ? Object.keys(JSON.parse(tr.merchantDescription))
                    : []"
                >
                  <span class="text-grey">{{ item }}:</span>
                  {{ JSON.parse(tr.merchantDescription)[item] }}
                </span>
              </template>
            </vs-td>
            <vs-td class="d-only">
              <a @click="showTransaction(tr.transactionId)">جزئیات</a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="()=>{getData();}"
      />
    </vx-card>
    <transaction-details ref="TransactionDetails1"></transaction-details>
  </div>
</template>
<style>
.remove-nav {
  background: #ea5455;
  color: #eee;
}
.excel-import div,
.remove-nav {
  padding-top: 0 !important;
  padding-bottom: 17px !important;
}
.excel-import div span,
.remove-nav span {
  display: inline-block !important;
  bottom: -1em;
  margin-left: 1em;
}
.is-blocked {
  border-width: 0;
  border-left-width: 6px;
  border-right-width: 6px;
  border-style: dashed;
  border-color: red;
}
</style>
<script>
import VueApexCharts from "vue-apexcharts";
//import apexChatData from './apexChartData.js'
import ShareLinks from "./ShareLinks.vue";
import json2xlsx from "json2xlsx-export";
import TransactionDetails from "../transaction/TransactionDetails.vue";
import { BillState } from "@/enums.js";
import Vue from "vue";
import draggable from "vuedraggable";
export default {
  components: {
    VueApexCharts,
    ShareLinks,
    TransactionDetails,
    draggable,
  },
  data() {
    return {
      tableData: [],
      downloadData: [],
      paginationPageSize: 20,
      saerchText: "",
      filters: {
        consumerMobile: "",
        consumerName: "",
        merchantDescription: "",
        transactionDateTo: "",
        transactionDateFrom: "",
        billTitle: "",
        billDescription: "",
      },
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      popupActive: false,
      BillState,
    };
  },
  watch: {},
  computed: {},
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filters.consumerMobile =
          this.$route.query.m || this.filters.consumerMobile;
        this.filters.consumerName =
          this.$route.query.n || this.filters.consumerName;
        this.filters.merchantDescription =
          this.$route.query.d || this.filters.merchantDescription;
        this.filters.billTitle = this.$route.query.t || this.filters.billTitle;
        this.filters.billDescription =
          this.$route.query.e || this.filters.billDescription;
        this.filters.minAmount = this.$route.query.na || this.filters.minAmount;
        this.filters.maxAmount = this.$route.query.xa || this.filters.maxAmount;
        this.filters.transactionDateFrom =
          this.$route.query.df || this.filters.transactionDateFrom;
        this.filters.transactionDateTo =
          this.$route.query.dt || this.filters.transactionDateTo;
        this.filters.billState = this.$route.query.bs
          ? this.billStateList.find((x) => x.value == this.$route.query.bs)
          : null;
      }
    },
    async getData(download = false) {
      const selectedAccount = this.$store.getters["account/default"];
      if (!selectedAccount) {
        this.$helper.selectAccount();
        return;
      }
      const headers = {
        AccountId: selectedAccount.id,
      };
      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: (this.pageNo - 1) * this.pageSize,
          consumerMobile: this.filters.consumerMobile,
          consumerName: this.filters.consumerName,
          merchantDescription: this.filters.merchantDescription,
          billTitle: this.filters.billTitle,
          billDescription: this.filters.billDescription,
          minAmount: this.filters.minAmount,
          maxAmount: this.filters.maxAmount,
        },
        headers: {
          AccountId: selectedAccount.id,
        },
      };
      const query = {};
      if (this.$route.query.userId) {
        query.shopName = this.$route.query.shopName;
        query.userId = this.$route.query.userId;
        payload.params.userId = this.$route.query.userId;
      }
      query.ps = this.pageSize;
      query.pno = "" + this.pageNo;
      if (this.filters.maxAmount) query.xa = this.filters.maxAmount;
      if (this.filters.minAmount) query.na = this.filters.minAmount;
      if (this.filters.consumerMobile) query.m = this.filters.consumerMobile;
      if (this.filters.consumerName) query.n = this.filters.consumerName;
      if (this.filters.merchantDescription)
        query.d = this.filters.merchantDescription;
      if (this.filters.billTitle) query.t = this.filters.billTitle;
      if (this.filters.billDescription) query.e = this.filters.billDescription;
      if (this.filters.billState) query.bs = this.filters.billState.value;
      if (this.filters.transactionDateFrom != "") {
        payload.params.transactionDateFrom = this.$moment(
          this.filters.transactionDateFrom,
          "jYYYY/jMM/jDD"
        ).format();
        query.df = this.filters.transactionDateFrom;
      }
      if (this.filters.transactionDateTo != "") {
        payload.params.transactionDateTo = this.$moment(
          this.filters.transactionDateTo,
          "jYYYY/jMM/jDD"
        ).format("YYYY-MM-DDT23:59:59.9999999Z");
        query.dt = this.filters.transactionDateTo;
      }
      if (!this.$helper.equal(this.$route.query, query))
        this.$router.replace({
          query: query,
        });
      if (download) {
        payload.params.MaxResultCount = this.totalCount;
        payload.params.SkipCount = 0;
      }
      this.$vs.loading();
      await this.$http
        .get("api/services/app/Bills/GetPaidBillForMerchant", payload)
        .then((response) => {
          if (download) {
            this.downloadData = response.data.result.items;
          } else {
            this.tableData = response.data.result.items;
            this.totalCount = response.data.result.totalCount;
            this.pagesCount =
              Math.floor((this.totalCount - 1) / this.pageSize) + 1;
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData(false);
    },
    showTransaction(id) {
      this.$refs.TransactionDetails1.show(id);
    },
    clear() {
      this.filters.consumerMobile = "";
      this.filters.consumerName = "";
      this.filters.merchantDescription = "";
      this.filters.transactionDateTo = "";
      this.filters.transactionDateFrom = "";
      this.filters.minAmount = "";
      this.filters.maxAmount = "";
      this.filters.billTitle = "";
      this.filters.billDescription = "";
    },
    showDownloadPopup() {
      this.popupActive = true;
    },
    async download(type) {
      this.downloadData = null;
      await this.getData(true);
      if (this.downloadData == null) return;
      const fileName = "PaidBills";
      const exportType = "xls";
      const header = [
        [
          {
            value: "نام پرداخت کننده",
            type: "string",
          },
          {
            value: "موبایل پرداخت کننده",
            type: "string",
          },
          {
            value: "مبلغ",
            type: "string",
          },
          {
            value: "تاریخ پرداخت",
            type: "string",
          },
          {
            value: "وضعیت",
            type: "string",
          },
        ],
      ];
      const data = this.downloadData.map((x) => {
        return [
          {
            value: !x.consumerName
              ? !x.contactName
                ? x.consumerMobile
                : x.contactName
              : x.consumerName,
            type: "string",
          },
          {
            value:
              x.consumerMobile == null
                ? /^(\+98|0)9\d{9}$/.test(x.consumerName)
                  ? x.consumerName
                  : ""
                : x.consumerMobile,
            type: "string",
          },
          { value: x.amount, type: "string" },
          {
            value:
              x.paymentTransactionDateTime == undefined ||
              x.paymentTransactionDateTime == "0001-01-01T00:00:00"
                ? "-"
                : this.$moment(x.paymentTransactionDateTime).format(
                    "jYYYY/jMM/jDD - HH:mm:ss"
                  ),
            type: "string",
          },
          { value: BillState[x.billState].title, type: "string" },
          { value: x.merchantDescription, type: "string" },
        ];
      });
      switch (type) {
        case 1:
          this.addDescriptionToExcelFile1(header, data);
          break;
        case 2:
          this.addDescriptionToExcelFile2(header, data);
          break;
        case 3:
          this.addDescriptionToExcelFile3(header, data);
          break;
        case 4:
          this.addDescriptionToExcelFile4(header, data);
          break;
      }
      const data2 = [...header, ...data];
      const config = {
        filename: fileName,
        sheets: [
          {
            name: fileName,
            data: data2,
          },
        ],
      };

      json2xlsx(config);
    },
    addDescriptionToExcelFile1(header, data) {
      if (!data && !data.length > 0) return;
      let headers = [];
      data.forEach((x) => {
        if (
          x &&
          x.length > 0 &&
          x[x.length - 1].type == "string" &&
          x[x.length - 1].value
        ) {
          let cells = [];
          headers.forEach((y) => cells.push({ value: "", type: "string" }));
          let s = x[x.length - 1].value;
          if (this.$helper.isJSON(s)) {
            let ds = JSON.parse(x[x.length - 1].value);
            x.splice(x.length - 1, 1);
            Object.keys(ds).forEach((key) => {
              let i = headers.indexOf(key.replace(/ /g, ""));
              if (i == -1) {
                headers.push(key.replace(/ /g, ""));
                header[0].push({
                  value: key,
                  type: "string",
                });
                cells.push({ value: ds[key], type: "string" });
              } else {
                cells[i].value = ds[key];
              }
            });
            cells.forEach((y) => x.push(y));
          }
        }
      });
    },
    addDescriptionToExcelFile2(header, data) {
      if (!data && !data.length > 0) return;

      header[0].push({
        value: "توضیحات 1",
        type: "string",
      });

      data.forEach((x) => {
        if (
          x &&
          x.length > 0 &&
          x[x.length - 1].type == "string" &&
          x[x.length - 1].value
        ) {
          let s = x[x.length - 1].value;
          if (this.$helper.isJSON(s)) {
            let ds = JSON.parse(s);
            x[x.length - 1].value = "";
            Object.keys(ds).forEach((y) => {
              x[x.length - 1].value += y + ": " + ds[y] + "،\n";
            });
          }
        }
      });
    },
    addDescriptionToExcelFile3(header, data) {
      if (!data && !data.length > 0) return;

      for (let i = 1; i <= 3; i++) {
        header[0].push({
          value: "عنوان توضیحات " + i,
          type: "string",
        });
        header[0].push({
          value: "مقدار توضیحات " + i,
          type: "string",
        });
      }

      data.forEach((x) => {
        if (
          x &&
          x.length > 0 &&
          x[x.length - 1].type == "string" &&
          x[x.length - 1].value
        ) {
          let s = x[x.length - 1].value;
          x.splice(x.length - 1, 1);
          if (this.$helper.isJSON(s)) {
            let ds = JSON.parse(s);
            Object.keys(ds).forEach((y) => {
              x.push({ value: y, type: "string" });
              x.push({ value: ds[y], type: "string" });
            });
          } else {
            x.push({ value: "توضیحات", type: "string" });
            x.push({ value: s, type: "string" });
          }
        }
      });
    },
    addDescriptionToExcelFile4(header, data) {
      if (!data && !data.length > 0) return;

      for (let i = 1; i <= 3; i++) {
        header[0].push({
          value: "توضیحات " + i,
          type: "string",
        });
      }

      data.forEach((x) => {
        if (
          x &&
          x.length > 0 &&
          x[x.length - 1].type == "string" &&
          x[x.length - 1].value
        ) {
          let s = x[x.length - 1].value;
          x.splice(x.length - 1, 1);
          if (this.$helper.isJSON(s)) {
            let ds = JSON.parse(s);
            Object.keys(ds).forEach((y) => {
              x.push({ value: ds[y], type: "string" });
            });
          } else {
            x.push({ value: s, type: "string" });
          }
        }
      });
    },
  },
  mounted() {
    this.initFilters();
    this.getData(false);
  },
};
</script>
